import { CreateUserBundleServiceMappingInterface } from "../interfaces/UserBundleServiceMappingInterfaces/CreateUserBundleServiceMappingInterface";
import { UserBundleServiceMappingInterface } from "../interfaces/UserBundleServiceMappingInterfaces/UserBundleServiceMappingInterface";
import BaseService from "./BaseService";

export class UserBundleServiceMappingService extends BaseService<UserBundleServiceMappingInterface, CreateUserBundleServiceMappingInterface>{ 
    constructor(){
        let url: string = '/user-bundle-service-mapping/admin'
        super(url)
    }
}